// ================================================================
// Voice Node — Configuration Schema
// ================================================================
// نود صوتی: تماس/پاسخ‌گوی صوتیِ هوشمند

export const voiceConfigSchema = {
  fields: [
    // 1) ارائه‌دهنده‌ی سرویس صوتی
    {
      key: 'provider',
      type: 'select',
      labelKey: 'nodes.voice.fields.provider',
      placeholderKey: 'nodes.voice.placeholders.provider',
      required: true,
      options: [
        { value: 'twilio',     labelKey: 'nodes.voice.options.twilio' },
        { value: 'vapi',       labelKey: 'nodes.voice.options.vapi' },
        { value: 'elevenlabs', labelKey: 'nodes.voice.options.elevenlabs' }
      ]
    },

    // 2) شماره تماس
    {
      key: 'phoneNumber',
      type: 'text',
      labelKey: 'nodes.voice.fields.phoneNumber',
      placeholderKey: 'nodes.voice.placeholders.phoneNumber',
      icon: 'call'
    },

    // 3) نوع صدا
    {
      key: 'voice',
      type: 'select',
      labelKey: 'nodes.voice.fields.voice',
      placeholderKey: 'nodes.voice.placeholders.voice',
      options: [
        { value: 'female',  labelKey: 'nodes.voice.options.female' },
        { value: 'male',    labelKey: 'nodes.voice.options.male' },
        { value: 'neutral', labelKey: 'nodes.voice.options.neutral' }
      ]
    },

    // 4) پیام خوش‌آمد
    {
      key: 'greeting',
      type: 'textarea',
      labelKey: 'nodes.voice.fields.greeting',
      placeholderKey: 'nodes.voice.placeholders.greeting'
    }
  ]
};
